export const SETTINGS_STORAGE_KEY = "settings";

export type AppSettings = {
  autoPlayOnCorrect: boolean;
};

const DEFAULT_SETTINGS: AppSettings = {
  autoPlayOnCorrect: false,
};

export function readAppSettings(): AppSettings {
  try {
    const raw = localStorage.getItem(SETTINGS_STORAGE_KEY);
    if (!raw) {
      return { ...DEFAULT_SETTINGS };
    }
    const data = JSON.parse(raw) as Partial<AppSettings>;
    return {
      autoPlayOnCorrect: data.autoPlayOnCorrect === true,
    };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

export function writeAppSettings(settings: AppSettings): void {
  try {
    localStorage.setItem(SETTINGS_STORAGE_KEY, JSON.stringify(settings));
  } catch {
  }
}

export function patchAppSettings(partial: Partial<AppSettings>): AppSettings {
  const next = { ...readAppSettings(), ...partial };
  writeAppSettings(next);
  return next;
}
